import { render, staticRenderFns } from "./IconArrowCircleUpSolid.vue?vue&type=template&id=c1b144f8"
import script from "./IconArrowCircleUpSolid.vue?vue&type=script&lang=js"
export * from "./IconArrowCircleUpSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports